import React, { useState } from "react";

import footerLogo from "../assets/Footerimg/dailypaysymbol.webp";
import footerGirl from "../assets/Footerimg/footer-girl.svg";
import footerCard from "../assets/Footerimg/footerphone.webp";

import appstore from "../assets/Footerimg/app-store.svg";
import playstore from "../assets/Footerimg/playstore.svg";
import languageLogo from "../assets/Footerimg/us-flag-circle.svg";

function Footer() {

  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };
return (
  <footer className="w-full bg-white overflow-hidden">

    {/* ================= DESKTOP ================= */}
    <div className="hidden lg:block">

      {/* TOP BORDER */}
      <div className="w-[85%] mx-auto border-t border-gray-300"></div>

      {/* MAIN */}
      <div
        className="
          max-w-[1500px]
          mx-auto
          px-6
          md:px-10
          xl:px-16
          pt-10
          pb-6
        "
      >

        {/* TOP GRID */}
        <div className="flex items-start gap-10 xl:gap-16 justify-start">

          {/* LEFT */}
          <div className="ml-2 sm:ml-4 md:ml-8 flex-shrink-0">

            {/* LOGO */}
            <img
              src={footerLogo}
              alt="logo"
              className="
                hidden sm:block
                w-[50px]
                md:w-[65px]
                lg:w-[70px]
                mt-6
                ml-2 md:ml-6
              "
            />

            {/* ADDRESS */}
            <div className="mt-5">

              <h3 className="text-[#1e1f22] font-bold text-[15px]">
                PayMeDaily HQ
              </h3>

              <p className="mt-3 text-[#071a4d] leading-[1.3] text-[15px]">
                55 Water Street
                <br />
                New York, NY 10041
              </p>

              <button className="mt-2 text-orange-600 font-semibold text-[16px]">
                Contact us →
              </button>

            </div>

            {/* SOCIALS */}
            <div className="flex items-center gap-3 mt-7 flex-wrap">

              <div className="w-8 h-8 rounded-full bg-[#071a4d] text-white flex items-center justify-center text-[12px] font-bold">
                f
              </div>

              <div className="w-8 h-8 rounded-full bg-[#071a4d] text-white flex items-center justify-center text-[12px] font-bold">
                X
              </div>

              <div className="w-8 h-8 rounded-full bg-[#071a4d] text-white flex items-center justify-center text-[12px] font-bold">
                in
              </div>

              <div className="w-8 h-8 rounded-full bg-[#071a4d] text-white flex items-center justify-center text-[12px] font-bold">
                ig
              </div>

              <div className="w-8 h-8 rounded-full bg-[#071a4d] text-white flex items-center justify-center text-[12px] font-bold">
                yt
              </div>

            </div>

          </div>

          {/* 4 COLUMNS GRID */}
          <div
            className="
              flex
              items-start
              justify-center
              gap-5
              xl:gap-8
              flex-1
              ml-4
              lg:ml-10
              xl:ml-16
              mt-6
              flex-wrap
            "
          >

            {/* COMPANY */}
            <div className="min-w-[160px]">

              <h3 className="text-[#071a4d] font-bold text-[18px]">
                Company
              </h3>

              <div className="mt-6 flex flex-col gap-3 text-[14px] text-[#16181e]">

                <p className="hover:underline hover:text-orange-500 text-orange cursor-pointer">
                  About Us
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Awards & Recognition
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Impact
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Security
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Compliance
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Press Center
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Careers
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  PaymeDaily Pioneers
                </p>

              </div>

            </div>

            {/* EMPLOYERS */}
            <div className="min-w-[160px]">

              <h3 className="text-[#071a4d] font-bold text-[18px]">
                For Employers
              </h3>

              <div className="mt-6 flex flex-col gap-3 text-[14px] text-[#0c0c10]">

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Overview
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Why DailyPay
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Clients
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Industries
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Channel Partners
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Integrations
                </p>

              </div>

            </div>

            {/* PLATFORM */}
            <div className="min-w-[180px]">

              <h3 className="text-[#071a4d] font-bold text-[18px] ml-0 lg:ml-3">
                Platform & Features
              </h3>

              <div className="mt-6 flex flex-col gap-3 text-[14px] text-[#111215] ml-0 lg:ml-3">

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  DailyPay Platform
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  DailyPay Visa® Prepaid Card
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Cycle
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Reward
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Tips
                </p>

              </div>

            </div>

            {/* RESOURCES */}
            <div className="min-w-[180px]">

              <h3 className="text-[#071a4d] font-bold text-[18px] ml-0 lg:ml-2">
                Resources
              </h3>

              <div className="mt-6 flex flex-col gap-3 text-[14px] text-[#0a0a0e] ml-0 lg:ml-2">

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Blog
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  On-Demand Pay Education Series
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Employee Turnover Calculator
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Integrations
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Employee Retention
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  On-Demand Pay
                </p>

                <p className="hover:underline hover:text-orange-500 cursor-pointer">
                  Resource Center
                </p>

              </div>

            </div>

          </div>

        </div>

        {/* BOTTOM */}
        <div
          className="
            mt-14
            flex
            items-end
            justify-between
            gap-6
            flex-wrap
          "
        >

          {/* LANGUAGE */}
          <div className="flex gap-3"></div>

          {/* GIRL */}
          <>
            <img
              src={footerGirl}
              alt="girl"
              style={{
                animation: "float 4s ease-in-out infinite",
              }}
              className="
                w-[120px]
                md:w-[140px]
                lg:w-[150px]
                h-auto
                lg:-ml-[250px]
                lg:-mt-[300px]
                lg:-translate-y-[150px]
              "
            />

            <style>
              {`
                @keyframes float {
                  0% {
                    transform: translateY(0px) translateX(0px);
                  }

                  25% {
                    transform: translateY(-8px) translateX(4px);
                  }

                  50% {
                    transform: translateY(0px) translateX(8px);
                  }

                  75% {
                    transform: translateY(8px) translateX(4px);
                  }

                  100% {
                    transform: translateY(0px) translateX(0px);
                  }
                }
              `}
            </style>
          </>

          {/* EMPLOYEE CARD */}
          <div className="w-full max-w-[460px] lg:mr-12 mb-0">

            <h3 className="text-[#071a4d] font-bold text-[18px] mb-4 lg:translate-y-[100px]">
              For Employees
            </h3>

            <a
              href="https://get.dailypay.com"
              target="_blank"
              rel="noreferrer"
              className="block lg:translate-y-[100px]"
            >

              <div
                className="
                  relative
                  w-full
                  bg-white
                  rounded-[20px]
                  border
                  border-gray-100
                  shadow-sm
                  p-4
                  min-h-[40px]
                  transition-all
                  duration-200
                  hover:shadow-md
                "
              >

                <div className="absolute top-2 right-4 md:right-6 flex h-9 w-9 items-center justify-end rounded-full bg-transparent text-[#071a4d] text-lg shadow-sm">
                  ↗
                </div>

                <div className="flex items-center gap-4">

                  <div className="w-[62px] h-[86px] flex-shrink-0 rounded-[24px] bg-transparent flex items-center justify-center">

                    <img
                      src={footerCard}
                      alt="phone"
                      className="
                        w-[55px]
                        md:w-[70px]
                        h-auto
                        object-cover
                        mt-2
                        md:mt-4
                      "
                    />

                  </div>

                  <div className="flex-1 min-w-0">

                    <p className="text-[#f97316] font-extrabold text-[28px] md:text-[35px] leading-[1.05] break-words">
                      PayMeDaily.
                    </p>

                    <p className="mt-1 text-[#131417] text-[13px] md:text-[16px] font-semibold break-all">
                      visit get.PayMeDaily.com
                    </p>

                  </div>

                </div>

              </div>

            </a>

          </div>

        </div>

      </div>

    </div>

      {/* ================= MOBILE + TABLET ================= */}
      {/* ================= MOBILE + TABLET ================= */}
      <div className="block lg:hidden px-4 py-6">

        {/* TOP BORDER */}
        <div className="border-t border-gray-300 mb-6"></div>

  {/* ACCORDION */}
  <div className="space-y-4">

    {/* COMPANY */}
    <div className="border-b border-gray-300 pb-4">

      <button
        onClick={() => toggleMenu("company")}
        className="
          w-full
          flex
          items-center
          justify-between
          text-[#071a4d]
          font-bold
          text-[20px]
        "
      >
        Company
        <span className="text-xl">⌄</span>
      </button>

      {openMenu === "company" && (
        <div className="mt-4 flex flex-col gap-3 text-[#071a4d] text-[16px]">
          <p>About Us</p>
          <p>Awards & Recognition</p>
          <p>Impact</p>
          <p>Security</p>
          <p>Compliance</p>
        </div>
      )}

    </div>

    {/* EMPLOYERS */}
    <div className="border-b border-gray-300 pb-4">

      <button
        onClick={() => toggleMenu("employers")}
        className="
          w-full
          flex
          items-center
          justify-between
          text-[#071a4d]
          font-bold
          text-[20px]
        "
      >
        For Employers
        <span className="text-xl">⌄</span>
      </button>

      {openMenu === "employers" && (
        <div className="mt-4 flex flex-col gap-3 text-[#071a4d] text-[16px]">
          <p>Overview</p>
          <p>Why DailyPay</p>
          <p>Clients</p>
          <p>Industries</p>
        </div>
      )}

    </div>

    {/* PLATFORM */}
    <div className="border-b border-gray-300 pb-4">

      <button
        onClick={() => toggleMenu("platform")}
        className="
          w-full
          flex
          items-center
          justify-between
          text-[#071a4d]
          font-bold
          text-[20px]
        "
      >
        Platform & Features
        <span className="text-xl">⌄</span>
      </button>

      {openMenu === "platform" && (
        <div className="mt-4 flex flex-col gap-3 text-[#071a4d] text-[16px]">
          <p>DailyPay Platform</p>
          <p>Visa Prepaid Card</p>
          <p>Cycle</p>
          <p>Reward</p>
        </div>
      )}

    </div>

    {/* RESOURCES */}
    <div className="border-b border-gray-300 pb-4">

      <button
        onClick={() => toggleMenu("resources")}
        className="
          w-full
          flex
          items-center
          justify-between
          text-[#071a4d]
          font-bold
          text-[20px]
        "
      >
        Resources
        <span className="text-xl">⌄</span>
      </button>

      {openMenu === "resources" && (
        <div className="mt-4 flex flex-col gap-3 text-[#071a4d] text-[16px]">
          <p>Blog</p>
          <p>Research</p>
          <p>Resource Center</p>
        </div>
      )}

    </div>

  </div>

 

    {/* CARD */}
   {/* FOR EMPLOYEES CARD */}
    <div className="mt-10">

      {/* TITLE */}
      <h3 className="text-[#071a4d] font-bold text-[22px] mb-4">
        For Employees
      </h3>

      <a
        href="https://devpaydaily.com/"
        target="_blank"
        rel="noreferrer"
        className="block"
      >
        <div
          className="
            relative
            w-full
            max-w-[320px]
            bg-white
            rounded-[32px]
            border border-gray-100
            shadow-sm
            p-4
            transition-all
            duration-200
            hover:shadow-md
          "
        >
          <div className="absolute top-3 right-3 sm:right-4 md:right-4  flex h-9 w-9 items-center justify-center rounded-full border border-gray-200 bg-white text-[#071a4d] text-lg shadow-sm">
            ↗
          </div>

          <div className="flex items-center gap-4">
            <div className="w-[62px] h-[86px] flex-shrink-0 rounded-[24px] bg-[#f8fafc] flex items-center justify-center">
              <img
                src={footerCard}
                alt="phone"
                className="w-[48px] h-[78px] object-contain"
              />
            </div>


            <div className="flex-1">
              <p className="text-[#f97316] font-extrabold text-[28px] leading-[1.05]">
                PaymeDaily.
              </p>
              <p className="mt-1 text-[#071a4d] text-[12px] font-semibold">
                visit get.dailypay.com
              </p>
            </div>
          </div>
        </div>
      </a>

    </div>

  {/* GIRL */}
  <div className="flex justify-center mt-10">

    <img
      src={footerGirl}
      alt="girl"
      className="
        w-[170px]
        sm:w-[220px]
        object-contain
      "
    />

  </div>

  {/* LANGUAGE */}
  {/* <div className="flex items-center gap-3 mt-8">

    <span className="text-[20px]">🇺🇸</span>

    <p className="text-[#071a4d] font-bold text-[18px]">
      EN
    </p>

  </div> */}

  {/* APP TEXT */}
  <p
    className="
      mt-8
      text-[#071a4d]
      font-bold
      text-[18px]
    "
  >
    Get the PayMeDaily app
  </p>

  {/* STORE BUTTONS */}
  <div className="flex items-center gap-3 mt-4">

    <img
      src={appstore}
      alt="appstore"
      className="w-[130px]"
    />

    <img
      src={playstore}
      alt="playstore"
      className="w-[130px]"
    />

  </div>

  {/* LOGO */}
  <img
    src={footerLogo}
    alt="logo"
    className="hidden sm:block w-[90px] mt-10"
  />

  {/* SOCIALS */}
  <div className="flex items-center gap-4 mt-6">

    <div className="w-8 h-8 rounded-full bg-[#071a4d] text-white flex items-center justify-center text-[11px] font-bold">
      f
    </div>

    <div className="w-8 h-8 rounded-full bg-[#071a4d] text-white flex items-center justify-center text-[11px] font-bold">
      X
    </div>

    <div className="w-8 h-8 rounded-full bg-[#071a4d] text-white flex items-center justify-center text-[11px] font-bold">
      in
    </div>

    <div className="w-8 h-8 rounded-full bg-[#071a4d] text-white flex items-center justify-center text-[11px] font-bold">
      ig
    </div>

    <div className="w-8 h-8 rounded-full bg-[#071a4d] text-white flex items-center justify-center text-[11px] font-bold">
      yt
    </div>

  </div>

</div>





{/* ================= LEGAL SECTION ================= */}

<div className="w-full bg-white px-4 sm:px-6 md:px-10 lg:px-16 py-8 md:py-10 text-[#2f3b52] overflow-hidden">


    <div className="flex  gap-3 ">

  <img
    src={languageLogo}
    alt="language"
    className="w-[24px] h-[24px] ml-16 mb-6 "
  />

  <p className="text-[#071a4d] font-bold text-[18px] ">
    EN
  </p>

</div>

  {/* TOP BORDER */}
  <div className="border-t border-gray-300 pt-6 md:pt-8 w-[90%]  mx-auto "></div>

    {/* LINKS */}
   <div
  className="
    flex flex-wrap
    gap-x-4 sm:gap-x-7 md:gap-x-8
    gap-y-3 md:gap-y-4
    text-[10px] sm:text-[13px] md:text-[13px]
    leading-4 md:leading-5
    text-black
    px-4 sm:px-6 md:px-10
    ml-2 sm:ml-4 md:ml-8
  "
>
      <p>© DailyPay 2026</p>

      <a href="/" className="hover:text-orange-500">
        Privacy
      </a>

      <a href="/" className="hover:text-orange-500">
        Do Not Sell or Share My Personal Information
      </a>

      <a href="/" className="hover:text-orange-500">
        Consumer Privacy Notice
      </a>

      <a href="/" className="hover:text-orange-500">
        Accessibility
      </a>

      <a href="/" className="hover:text-orange-500">
        Terms of Service
      </a>

      <a href="/" className="hover:text-orange-500">
        OSS Attribution
      </a>

      <a href="/" className="hover:text-orange-500">
        Program Terms
      </a>

      <a href="/" className="hover:text-orange-500">
        Status
      </a>
    </div>

    {/* SECOND BORDER */}
    <div
      className="
        border-t border-gray-300
        mt-6 md:mt-10
        pt-6 md:pt-10
        pl-0 sm:pl-2 md:pl-2
        space-y-1
        text-[10px] sm:text-[12px]
        leading-5 md:leading-6
        text-gray-600
        w-[90%]
            mx-auto

      "
    >

      <p>
        App Store, Apple Pay, and the Apple Logo are trademarks of Apple Inc.
        Google, Google Play, and Google Pay are trademarks of Google LLC.
        Samsung Pay is a registered trademark of Samsung Electronics Co.,<br /> Ltd.
        All other trademarks shown are the property of their respective owners.
      </p>

      <p>
        The DailyPay Visa® Prepaid Card is issued by The Bancorp Bank, N.A.,
        Member FDIC, pursuant to a license from Visa U.S.A. Inc. and can be
        used everywhere Visa debit cards are accepted.
      </p>

      <p>
        Your funds are FDIC insured through The Bancorp Bank, N.A., Member FDIC.
        DailyPay is not FDIC-insured. Deposit insurance coverage only protects
        against failure of The Bancorp Bank, N.A.
      </p>

      <p>
        DailyPay, LLC's Earned Wage License Number in Nevada is EWA00004.
      </p>

      <p>
        DailyPay, LLC's Earned Wage License Number in Wisconsin is 2587396EWA.
      </p>

      <p className="mb-10">
        DailyPay, LLC's{" "}
        <a href="/" className="underline">
          NMLS
        </a>{" "}
        ID is 2587396.
      </p>

    </div>
  </div>
{/* </div> */}

    </footer>
  );
}

export default Footer;